module.exports = __webpack_public_path__ + "media/images/common/caret-down-e8581ed57b5ff527b072acf47e678614.svg";